import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import * as printJS from 'print-js';
import { CdcLojaRestService } from '../../../omni-rest/cdc/cdc-loja-rest.service';
import { appSettings } from './../../../../environments/app.setings';
import { VisualizaImagemComponent } from './../visualiza-imagem/visualiza-imagem.component';
import { VisualizacaoDocumentacaoComponent } from './../visualizacao-documentacao/visualizacao-documentacao.component';
export class UploadDocumentationItemComponent {
    constructor(modalService, cdcLojaRestService) {
        this.modalService = modalService;
        this.cdcLojaRestService = cdcLojaRestService;
        this.fileChange = new EventEmitter();
        this.removeFileCallback = new EventEmitter();
        this.removeAllFilesCallback = new EventEmitter();
    }
    get hasFile() {
        return this.files && this.files.length;
    }
    get wasUploaded() {
        return (this.document.documentosEnviado &&
            this.document.documentosEnviado.length > 0);
    }
    get hasUploadDefined() {
        return this.document.url !== undefined;
    }
    get filesToUpload() {
        return this.files || [];
    }
    get uploadedFiles() {
        return this.document.documentosEnviado || [];
    }
    get mustShowAviso() {
        return this.timeline && this.timeline.filter(time => time.idStatus === 21)[0].dataHora === undefined;
    }
    show(imagem) {
        const initialState = { imagem };
        this.modalService.show(VisualizaImagemComponent, Object.assign({}, appSettings.MODAL_PARAMS, { initialState }));
    }
    print(document) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (document.url.includes('reports')) {
                this.cdcLojaRestService
                    .get(document.url, {}, 'arraybuffer')
                    .subscribe((res) => {
                    const pdfFile = new Blob([res.body], {
                        type: 'application/pdf',
                    });
                    const pdfUrl = URL.createObjectURL(pdfFile);
                    printJS({
                        printable: pdfUrl,
                        showModal: true,
                        modalMessage: 'Carregando documento...',
                    });
                });
            }
            else {
                window.open(document.url, '_blank').focus();
            }
        });
    }
    showAvisoDocumentacao() {
        const initialState = {};
        this.modalService.show(VisualizacaoDocumentacaoComponent, Object.assign({}, appSettings.MODAL_PARAMS, { initialState }));
    }
}
